// extracted by css-extract-rspack-plugin
export default {"panel":"tmqOJi4pxm0Sn1_C","applyButton":"W21seS_WZfQAtcJJ","clearValues":"jHCe65IU8is4WC4u"};